/**
 * MODULES - custom modal
 * @author PLEJ
 */

const recaptchaDelay = (() => {

    const init = () => {
        setTimeout( () => {
            appendScript();
        },2500);
    };

    const appendScript = () => {
        const script = document.createElement("script");
        script.src = 'https://www.google.com/recaptcha/api.js?render=6LdvtbMmAAAAAN-oVhRmf_LXm3SkXkyxHyENaN6C';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    };

    return {
        init: init
    };
})();

export {recaptchaDelay};
